import { _InjectableContext } from './injectable-context'

export const SSRContext = _InjectableContext.Provider
